/**
 * Custom hook to determine the current page type based on the window location.
 *
 * @returns An object containing boolean flags indicating the type of page:
 * - `isHomePage`: `true` if the current page is neither a collection nor a product detail page.
 * - `isAvailavity`: `true` if the current URL includes "collections".
 * - `isDetailOffer`: `true` if the current URL includes "products".
 */
export const usePage = () => {
    const isAvailavity = window.location.href.includes("collections");
    const isDetailOffer = window.location.href.includes("products");
    return {
        isHomePage: !isAvailavity && !isDetailOffer,
        isAvailavity,
        isDetailOffer
    };
};
